import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCreditCardPayment = (props: SVGProps<SVGSVGElement>) => (
  <svg width={26} height={30} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.146 7.526v19.527a1.762 1.762 0 0 0 1.762 1.76h12.73a1.76 1.76 0 0 0 1.76-1.76V2.947a1.76 1.76 0 0 0-1.76-1.761H6.908a1.762 1.762 0 0 0-1.762 1.76V7.64"
      fill="#ECF9F2"
    />

    <path
      d="M5.146 7.526v19.527a1.762 1.762 0 0 0 1.762 1.76h12.73a1.76 1.76 0 0 0 1.76-1.76V2.947a1.76 1.76 0 0 0-1.76-1.761H6.908a1.762 1.762 0 0 0-1.762 1.76V7.64"
      stroke="#194D33"
      strokeWidth={0.938}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M9.386 1.215V2.65a.407.407 0 0 0 .198.328.853.853 0 0 0 .48.142h6.957c.17.001.337-.048.48-.142a.407.407 0 0 0 .197-.328V1.215"
      stroke="#194D33"
      strokeWidth={0.938}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M1.281 8.281c0-.69.56-1.25 1.25-1.25h21.407c.69 0 1.25.56 1.25 1.25v13.531c0 .69-.56 1.25-1.25 1.25H2.53c-.69 0-1.25-.56-1.25-1.25V8.283Z"
      fill="#8CD9B2"
      stroke="#194D33"
      strokeWidth={0.938}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M3.632 13.814a.53.53 0 0 1 .528.527v1.055a.528.528 0 0 1-.324.486.526.526 0 0 1-.726-.486v-1.05a.539.539 0 0 1 .15-.376.53.53 0 0 1 .17-.116.54.54 0 0 1 .202-.04ZM6.27 14.34a.528.528 0 0 0-1.056 0v1.056a.528.528 0 1 0 1.057 0V14.34ZM7.857 13.814a.526.526 0 0 1 .486.324c.027.063.04.132.04.201v1.055a.528.528 0 0 1-1.055 0v-1.049a.512.512 0 0 1 .152-.377.547.547 0 0 1 .171-.116.554.554 0 0 1 .206-.038ZM9.97 13.814a.538.538 0 0 1 .373.154.525.525 0 0 1 .154.372v1.056a.525.525 0 0 1-.9.372.53.53 0 0 1-.157-.372v-1.05a.512.512 0 0 1 .153-.376.524.524 0 0 1 .377-.153v-.003ZM12.081 13.814a.528.528 0 0 1 .488.324c.026.064.04.132.04.201v1.055a.529.529 0 0 1-1.057 0v-1.049a.53.53 0 0 1 .325-.493.539.539 0 0 1 .204-.038ZM14.193 13.814a.53.53 0 0 1 .53.527v1.055c0 .139-.055.272-.153.372a.528.528 0 0 1-.575.114.523.523 0 0 1-.324-.486v-1.05a.539.539 0 0 1 .153-.376.527.527 0 0 1 .37-.156ZM16.31 13.814a.527.527 0 0 1 .528.527v1.055c0 .139-.055.273-.153.372a.53.53 0 0 1-.902-.372v-1.05c0-.069.013-.138.04-.202a.527.527 0 0 1 .278-.29.54.54 0 0 1 .209-.04ZM18.419 13.814a.526.526 0 0 1 .486.324c.026.063.04.132.039.201v1.055a.529.529 0 0 1-1.055 0v-1.049a.527.527 0 0 1 .53-.531ZM20.529 13.814a.527.527 0 0 1 .494.328.52.52 0 0 1 .038.205v1.055a.528.528 0 0 1-1.055 0v-1.055a.516.516 0 0 1 .152-.376.522.522 0 0 1 .37-.157ZM23.17 14.34a.528.528 0 0 0-1.054 0v1.056a.528.528 0 0 0 1.055 0V14.34Z"
      fill="#194D33"
    />

    <path
      d="M3.38 9.602a.366.366 0 0 0-.263.104.374.374 0 0 0-.115.258v1.913a.408.408 0 0 0 .03.14.4.4 0 0 0 .083.118.355.355 0 0 0 .264.102h3.47a.355.355 0 0 0 .264-.102.373.373 0 0 0 .114-.258V9.964a.373.373 0 0 0-.378-.362H3.38Z"
      fill="#ECF9F2"
      stroke="#194D33"
      strokeWidth={0.938}
      strokeLinejoin="round"
    />

    <path
      d="M23.027 18.647h-6.91a.329.329 0 1 0 0 .655h6.906a.329.329 0 0 0 0-.655h.005ZM23.056 19.951h-4.55a.329.329 0 1 0 0 .655h4.55a.327.327 0 0 0 .247-.568.329.329 0 0 0-.247-.087Z"
      fill="#194D33"
    />
  </svg>
);

const Memo = memo(SvgCreditCardPayment);

export default Memo;
